import SymbolSvg from '@/assets/assetfi/Symbol';
import { Box, Button, SxProps, Theme, Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import React from 'react';

interface CommonButtonPropsType {
  color: string;
  bgColor: string;
  text: string;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  variant: Variant;
  border?: string;
  sx?: SxProps<Theme>;
  icon?: string | null;
  disabled?: boolean;
}

const CommonButton = ({
  color,
  bgColor,
  text,
  handleClick,
  border,
  variant,
  sx,
  icon,
  disabled,
}: CommonButtonPropsType) => {
  return (
    <Button
      disabled={disabled}
      onClick={handleClick}
      sx={{
        background: bgColor,
        color: color,
        border: border ? `solid 1px ${border}` : 'none',
        '&:hover': {
          backgroundColor: bgColor,
        },
        ...sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '10px',
          alignItems: 'center',
          justifyContent: icon ? 'normal' : 'center',
        }}
      >
        {icon && <SymbolSvg width={16} height={16} />}
        <Typography
          variant={variant}
          sx={{
            textTransform: 'none',
            whiteSpace: 'nowrap',
          }}
        >
          {text}
        </Typography>
      </Box>
    </Button>
  );
};

export default CommonButton;
